import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { markAsReadNewArrivalNotifications } from 'api/new-arrival-notification.service';
import { NewArrivalNotificationRequest } from 'types/entity';

export const NEW_ARRIVAL_NOTIFICATION_UPDATE_STORE_NAME = 'newArrivalNotificationUpdate';

export const markASRead = createAsyncThunk(
  `${NEW_ARRIVAL_NOTIFICATION_UPDATE_STORE_NAME}/markASRead`,
  async (payload: { projectId: string, newArrivalNotificationRequest: NewArrivalNotificationRequest }) => {
    const { projectId, newArrivalNotificationRequest } = payload;
    await markAsReadNewArrivalNotifications(projectId, newArrivalNotificationRequest);
  },
);

export interface NewArrivalNotificationUpdateState {
  processing: boolean
  error: any
}

export const initialNewArrivalNotificationUpdateState: NewArrivalNotificationUpdateState = {
  processing: false,
  error: null,
};

export const newArrivalNotificationUpdateSlice = createSlice({
  name: NEW_ARRIVAL_NOTIFICATION_UPDATE_STORE_NAME,
  initialState: initialNewArrivalNotificationUpdateState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(markASRead.pending, (state) => {
      state.processing = true;
    });
    builder.addCase(markASRead.fulfilled, (state) => {
      state.processing = false;
    });
    builder.addCase(markASRead.rejected, (state, action) => {
      state.error = action.payload;
      state.processing = false;
    });
  },
});

export const newArrivalNotificationUpdateActions = {
  ...newArrivalNotificationUpdateSlice.actions,
  markASRead,
};

export default newArrivalNotificationUpdateSlice.reducer;
